import {
  HomeIcon,
  VideoCameraIcon,
  PencilSquareIcon,
  LightBulbIcon,
  CpuChipIcon,
  Squares2X2Icon,
  CalendarDaysIcon,
  SparklesIcon,
  SwatchIcon,
  PaintBrushIcon,
  RocketLaunchIcon,
  MegaphoneIcon,
  UserGroupIcon,
  ChatBubbleLeftRightIcon,
  GlobeAltIcon,
  Cog6ToothIcon,
  FunnelIcon,
  ChartBarIcon,
  CurrencyDollarIcon,
  LinkIcon,
} from '@heroicons/react/24/outline';

export const sidebarSections = [
  {
    title: 'Produção',
    items: [
      { icon: HomeIcon, label: 'Criar com IA', path: '/mp' },
      { icon: PaintBrushIcon, label: 'Criação Manual', path: '/manual-create' },
      { icon: VideoCameraIcon, label: 'Vídeos', path: '/videos' },
      { icon: PencilSquareIcon, label: 'Editar imagem', path: '/edit-image' },
      { icon: LightBulbIcon, label: 'Conteúdos', path: '/contents' },
      { icon: CpuChipIcon, label: 'Treinar IA', path: '/train-ai' }
    ]
  },
  {
    title: 'Gestão',
    items: [
      { icon: Squares2X2Icon, label: 'Dashboard', path: '/dashboard' },
      { icon: CalendarDaysIcon, label: 'Agendamento', path: '/scheduling' }
    ]
  },
  {
    title: 'Marketing',
    items: [
      { icon: MegaphoneIcon,             label: 'Marketing Pro',  path: '/mp' },
      { icon: SparklesIcon,              label: 'Campanhas',          path: '/campaigns' },
      { icon: RocketLaunchIcon,          label: 'Lançar Campanha',    path: '/campaign-launch' },
      { icon: SwatchIcon,                label: 'Identidade visual',  path: '/brand-identity' },
      { icon: FunnelIcon,                label: 'Funil de Vendas',  path: '/campaign-flow' },
      { icon: ChartBarIcon,              label: 'Minhas Campanhas',    path: '/mp/dashboard' },
      { icon: RocketLaunchIcon,          label: 'Jornada Eddy',       path: '/journey' },
      { icon: GlobeAltIcon,              label: 'Landing Page',       path: '/landing-builder' },
      { icon: ChatBubbleLeftRightIcon,   label: 'CRM de Leads',       path: '/crm' },
    ]
  },
  {
    title: 'Tráfego Pago',
    items: [
      { icon: CurrencyDollarIcon, label: 'Gerenciar Anúncios', path: '/ads-manager' },
      { icon: LinkIcon,           label: 'Conectar Contas',     path: '/ads/connect' },
    ]
  },
  {
    title: 'Especialistas',
    items: [
      { icon: UserGroupIcon,  label: 'Ser Especialista', path: '/specialist' },
      { icon: Cog6ToothIcon,  label: 'Config Admin MP',  path: '/admin/niche' },
    ]
  }
];
